import { SimpleFormComponentProps, SimpleFormMethods } from 'app/infrastructure/simple-form/types';
import { Textarea } from 'ui';
import * as React from 'react';

export const textareaCreator = (props: SimpleFormComponentProps, fieldMethods: SimpleFormMethods) =>
  <Textarea
    onChange={fieldMethods.handleChange(props.name)}
    componentId={props.name}
    className={props.className}
    label={fieldMethods.buildLabel(props.label)}
    value={fieldMethods.getProperty(props.name)}
    placeholder={props.placeholder}
    validation={fieldMethods.getValidation(props.name)}
    readOnly={props.readOnly}
    maxLength={props.maxLength}
    />;
